document.querySelectorAll('.menu-item__arrow').forEach(item => {
	item.addEventListener('click', (e) => {
		e.preventDefault()
		document.querySelector(item.dataset.program)?.classList.toggle('_open')
	})
})
document.querySelectorAll('.program-popup ').forEach(item => {
	item.querySelector('.program-popup__close').addEventListener('click', () => {
		item.classList.remove('_open')
	})
})